import {
  CButton,
  CButtonGroup,
  CCol,
  CFormGroup,
  CInput,
  CLabel,
  CRow,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { createItem, updateItem, ItemRequestStatus } from "../../api/generics";
import Errors, { getFieldErrors } from "../../models/errors";
import { SUCCESS } from "../../utils/constants/tags";
import { FieldErrors } from "../form/FieldErrors";
import { errorAlert } from "../utils/messages";
import { emptyValueOnUndefined } from "../../utils/fields";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import Subcompany, { newSubcompany } from "../../models/subcompany";

interface SubcompanyFormProps {
  initialSubcompany?: Subcompany;
  initialErrors?: Errors;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const SubcompanyForm: React.FC<SubcompanyFormProps> = ({
  initialSubcompany,
  initialErrors,
  onCancel,
  onSuccess,
}) => {
  const company = useSelector((state: RootState) => state.company.data.company);
  const [editingSubcompany, setEditingSubcompany] = useState<Subcompany>(
    initialSubcompany ? initialSubcompany : newSubcompany()
  );
  const [errors, setErrors] = useState<Errors>(
    initialErrors ? initialErrors : {}
  );
  const [submitting, setSubmitting] = useState(false);

  const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditingSubcompany({
      ...editingSubcompany,
      name: e.target.value,
    });
  };

  const onSave = async () => {
    setSubmitting(true);
    let toSendSubcompany = {
      ...editingSubcompany,
      companyId: company.id,
    };
    let requestPromise: Promise<ItemRequestStatus<Subcompany>>;
    if (editingSubcompany.id === undefined) {
      requestPromise = createItem<Subcompany>(
        "/subcompanies/create/",
        toSendSubcompany
      );
    } else {
      requestPromise = updateItem<Subcompany>(
        `/subcompanies/${toSendSubcompany.id}/`,
        toSendSubcompany
      );
    }

    const subcompaniestatus = await requestPromise;

    if (subcompaniestatus.status !== SUCCESS) {
      if (subcompaniestatus.errors !== undefined) {
        setErrors(subcompaniestatus.errors);
      }

      let message = "Ha ocurrido un error!!";
      if (subcompaniestatus.detail !== undefined) {
        message = subcompaniestatus.detail;
      }
      errorAlert(message);
    } else {
      setErrors({});
      clearForm();
      onSuccess();
    }
    setSubmitting(false);
  };

  const onClose = () => {
    clearForm();
    onCancel();
  };

  const clearForm = () => {
    setEditingSubcompany(newSubcompany());
  };

  useEffect(() => {
    setEditingSubcompany(
      initialSubcompany ? initialSubcompany : newSubcompany()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialSubcompany]);

  useEffect(() => {
    setErrors(initialErrors ? initialErrors : {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialErrors]);

  return (
    <>
      <fieldset disabled={submitting}>
        <CFormGroup>
          <CRow>
            <CCol md={2}>
              <CLabel>Nombre:</CLabel>
            </CCol>
            <CCol>
              <CInput
                type="text"
                value={emptyValueOnUndefined(editingSubcompany.name)}
                onChange={onNameChange}
                placeholder="Nombre"
              ></CInput>
              <FieldErrors
                errors={getFieldErrors("name", errors) as string[]}
              ></FieldErrors>
            </CCol>
          </CRow>
        </CFormGroup>
        <CFormGroup className="float-right">
          <CButtonGroup>
            <CButton type="button" color="secondary" onClick={onClose}>
              Atras
            </CButton>
            <CButton type="submit" color="primary" onClick={onSave}>
              {submitting ? (
                <Spinner
                  animation="grow"
                  style={{
                    height: "17px",
                    width: "17px",
                    marginTop: "auto",
                    marginBottom: "auto",
                    marginRight: "10px",
                  }}
                />
              ) : (
                <></>
              )}
              {submitting ? "Guardando..." : "Guardar"}
            </CButton>
          </CButtonGroup>
        </CFormGroup>
      </fieldset>
    </>
  );
};

export default SubcompanyForm;
